export default "__VITE_ASSET__BBLmLMhe__"